<template>
  <div>
    <base-header class="pb-6 pb-8 pt-5 pt-md-8 bg-default">
    </base-header>
    <b-container fluid class="mt--7">
      <b-card title="Crear nuevos usuarios">
        <b-card-body style="display: flex">
          <div class="col-lg-6 col-md-6 col-sm-12">
            <b-row class="form-group">
              <b-col md="10">
                <input v-model="name" class="form-control" placeholder="Nombres">
              </b-col>
            </b-row>
            <b-row class="form-group">
              <b-col md="10">
                <input v-model="phone" class="form-control" placeholder="Telefono">
              </b-col>
            </b-row>
            <b-row class="form-group">
              <b-col md="10">
                <select v-model="role" class="form-control">
                  <option value="client">CLIENTE</option>
                  <option value="administrator">ADMINISTRADOR</option>
                </select>
              </b-col>
            </b-row>


          </div>
          <div class="col-lg-6 col-md-6 col-sm-12">
            <b-row class="form-group">
              <b-col md="10">
                <input v-model="email" class="form-control" placeholder="Email">
              </b-col>
            </b-row>
            <b-row class="form-group">
              <b-col md="10">
                <input v-model="identification" class="form-control" placeholder="Identificacion">
              </b-col>
            </b-row>

            <b-row class="form-group">
              <b-col md="10">
                <input v-model="password" class="form-control" placeholder="Contraseña">
              </b-col>
            </b-row>
          </div>
        </b-card-body>
        <b-row>
          <b-col class="text-right">
            <b-button variant="primary" @click="createUser">Guardar</b-button>
          </b-col>
        </b-row>
      </b-card>
    </b-container>
    <b-modal id="modal_send_email" hide-footer>
      <h4>El usuario fue creado correctamente.</h4>
      <h5>Desea enviar email de bienvenida?</h5>
      <select name="" id="" v-model="company" class="form-control">
        <option value="">Seleccione una opcion</option>
        <option value="united">Bank United</option>
        <option value="amex">Bank America</option>
      </select>
      <input type="text" class="form-control mt-2" placeholder="Ingrese el numero de cuenta" v-model="account">
      <button class="btn btn-dark btn-block mt-2" @click="sendEmail">Si, Enviar email</button>
      <button class="btn btn-danger btn-block mt-2" @click="closeModal">No, No enviar email</button>
    </b-modal>
  </div>
</template>

<script>
import {post} from "@/util/axiosRequest";

export default {
  name: "Create",
  data: () => ({
    name: null,
    email: null,
    phone: null,
    identification: null,
    role: 'client',
    password: null,
    company: "",
    account: ""
  }),
  methods: {
    createUser() {
      if (this.name !== null && this.email !== null && this.phone !== null && this.identification !== null && this.role !== null && this.password !== null) {
        post("users/create", {
          name: this.name.toUpperCase(),
          email: this.email,
          phone: this.phone,
          identification: this.identification,
          type: this.role,
          password: this.password
        }, true).then(({data}) => {
          if(data == 200){
            this.$bvModal.show('modal_send_email')
          }else{
            this.showMessage('El email ya se encuentra registrado', 'error')
          }
        })
      } else {
        this.showMessage('Todos los campos son requeridos', 'error')
      }
    },
    clear() {
      this.name = null
      this.email = null
      this.phone = null
      this.identification = null
      this.role = null
      this.password = null
      this.company = ""
      this.account = ""
    },
    showMessage(message, type = 'success') {
      this.$swal({
        html: message,
        icon: (type === "success") ? 'success' : 'error',
        showCloseButton: true,
        show: false,
        confirmButtonColor: '#191c4d',
        cancelButtonColor: '#191c4d',
      });
    },
    async sendEmail(){
      if(this.company !== "" && this.company !== null && this.account !== "" && this.account !== null){
        this.$swal({
          html: 'El email se esta enviando por favor espere',
          timer: 3000,
          showCloseButton: true,
          show: false,
          confirmButtonColor: '#191c4d',
          cancelButtonColor: '#191c4d',
        });
        await post("users/send-email", {
          company: this.company,
          email: this.email,
          name: this.name.toUpperCase(),
          account: this. account
        }, true)
        this.showMessage("Email enviado correctamente", "success")
        this.closeModal()
      }else{
        this.showMessage('Toda la informacion es requerida', 'error')
      }
    },
    closeModal(){
      this.clear()
      this.$bvModal.hide('modal_send_email')
    }
  }
}
</script>

<style scoped>

</style>
